import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";

const money = (v, currency) => `${(v || 0).toFixed(2)} ${String(currency || "usd").toUpperCase()}`;

// جدول كلفة الوجه: صف لكل شركة أو موظف.
export const FaceCostTable = ({ title, rows = [], currency, showCompany = false, testId }) => {
  const { t } = useTranslation();

  return (
    <NeuCard data-testid={testId}>
      <p className="label-xs">{title}</p>
      {rows.length === 0 ? (
        <p className="mt-4 text-sm text-muted-foreground">{t("app.none")}</p>
      ) : (
        <ul className="mt-4 grid gap-2">
          {rows.map((r) => (
            <li
              key={r.id}
              data-testid={`${testId}-row-${r.id}`}
              className="grid gap-2 rounded-2xl p-3 shadow-neu-in sm:grid-cols-[1.6fr_repeat(4,minmax(0,1fr))] sm:items-center sm:text-center"
            >
              <div className="min-w-0 sm:text-start">
                <p className="truncate text-sm font-bold">{r.name}</p>
                {showCompany ? <p className="truncate text-[11px] text-muted-foreground">{r.company}</p> : null}
              </div>
              <Cell label={t("faceCost.checks")} value={r.checks} />
              <Cell label={t("faceCost.passed")} value={r.passed} accent />
              <Cell label={t("faceCost.failed")} value={r.failed} danger={r.failed > 0} />
              <Cell label={t("faceCost.cost")} value={money(r.total_cost, currency)} />
            </li>
          ))}
        </ul>
      )}
    </NeuCard>
  );
};

const Cell = ({ label, value, accent, danger }) => (
  <div className="sm:text-center">
    <p className="text-[10px] text-muted-foreground">{label}</p>
    <p className={`font-mono text-sm font-bold ${danger ? "text-destructive" : accent ? "text-primary" : ""}`}>
      <span className="num inline-block">{value}</span>
    </p>
  </div>
);
